/**
 * 评价卡片
 */
export interface ICsatData {
  inbox_id: number;
  content_type: string;
  processed_message_content: string;
  id: number;
  content: string;
  account_id: number;
  conversation_id: number;
  message_type: number;
  created_at: number;
  updated_at: string;
  private: boolean;
  status: string;
  source_id?: null | number;
  contentAttributes?: any;
  content_attributes: {
    submitted_values: {
      csat_survey_response: {
        // 反馈消息（ICastItem JSON String）
        feedback_message: string;
        // 评分
        rating: number;
      };
    };
  };
}

/**
 * 评价信息，由 feedback_message 解析而来
 */

export interface IFeedbackMessage {
  messages: ICastItem[];
  feedback: string;
  // 是否为 RTL 布局
  isRtl?: boolean;
}
interface ICastItem {
  rate: number;
  rateTitle: string; // B端展示标题
  comments: ICastComment[];
}
interface ICastComment {
  code: string; // 好评
  content: string;
  icon: string; // B端展示表情😊
  comments: ICastCommentItem[];
}
interface ICastCommentItem {
  code: string;
  content: string;
}

// Icon 组件的 Props 类型
export interface IconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  fill?: string;
}

export const parseCastItem = (jsonString: string): IFeedbackMessage | null => {
  let res: IFeedbackMessage | null = null;
  try {
    res = JSON.parse(jsonString);
  } catch (error) {
    console.error(`parseCastItem error: ${error}`);
  }
  return res;
};

/**
 * 获取评价卡片提交后的数据
 * 若未提交过，则 csat_survey_response 不存在，统一返回 null
 */
export const getCsatSurveyResponse = (message: ICsatData) => {
  const { content_attributes } = message ?? {};
  const { submitted_values } = content_attributes ?? {};
  const { csat_survey_response } = submitted_values ?? {};
  return csat_survey_response ?? null;
};
